<template>
    <div class="container-fluid px-0">
        <h1 class="page-title letraDelTitulo col-12">NOTIFICACIONES ELECTRÓNICAS</h1>
        <br />
        <div class="container-fluid">
            <div class="d-flex row px-lg-5">
                    <div id="irAlBuzonDeNotificacionesElectronicas_div" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 padding-div-low">
                        <div class="area-claro">
                            <h2>Buzón</h2>
                            <hr />
                            <div class="form-group">
                                <label>Ir a mi correo para ver mis notificaciones electrónicas</label>
                            </div>
                            <div class="text-right">
                                <a class="btn btn-primary overwrapDeBotones" id="irANotificacionesElectronicas" href="http://correo.poderjudicialags.gob.mx/" target="blank"><i class="fas fa-link"></i>&nbsp;&nbsp;Ir a buzón de Notificaciones Electrónicas</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 padding-div-low">
                        <div class="area-claro">
                            <h2>Nuevo correo electrónico</h2>
                            <h5>Aquí se puede generar un nuevo correo electrónico para las notificaciones electrónicas institucionales</h5>
                            <hr />
                            <div class="row d-flex">
                                <div class="form-group col-12">
                                    <label for="nombre">Nombre(s)</label>
                                    <input id="nombre" v-model="nombres" class="form-control form-control-claro" placeholder="Nombre(s)" />
                                </div>
                                <div class="form-group col-6">
                                    <label for="primerApellido">Primer apellido</label>
                                    <input id="primerApellido" v-model="primerApellido" class="form-control form-control-claro" placeholder="Primer apellido" />
                                </div>
                                <div class="form-group col-6">
                                    <label for="segundoApellido">Segundo apellido</label>
                                    <input id="segundoApellido" v-model="segundoApellido" class="form-control form-control-claro" placeholder="Segundo apellido" />
                                </div>
                                <div class="form-group col-12">
                                    <label for="correoElectronico">Correo electrónico personal</label>
                                    <input type="email" id="correoElectronico" v-model="correoElectronico" @input="(val) => (correoElectronico = correoElectronico.toLowerCase())" class="form-control form-control-claro" placeholder="Correo electrónico personal" v-on:keyup="ValidaQueSeanIdenticosLosCorreosPersonales(true)"/>
                                </div>
                                <div class="form-group col-12">
                                    <label for="confirmeCorreoElectronico">Confirme el correo electrónico personal</label>
                                    <input type="email" id="confirmeCorreoElectronico" v-model="confirmeCorreoElectronico" @input="(val) => (confirmeCorreoElectronico = confirmeCorreoElectronico.toLowerCase())" class="form-control form-control-claro" placeholder="Confirme el correo electrónico personal" v-on:keyup="ValidaQueSeanIdenticosLosCorreosPersonales(true)" />
                                </div>
                                <div class="form-group col-12" v-if="sonCorreosPersonalesIdenticos == false">
                                    <label class="rojo">Los correos personales ingresados no son los mismos.</label>
                                </div>
                                <div class="form-group col-12">
                                    <label for="correoElectronicoInstitucional">Correo electrónico institucional</label>
                                    <div class="input-group mb-3">
                                        <input class="form-control form-control-claro" v-model="correoElectronicoInstitucional" id="correoElectronicoInstitucional"  @input="(val) => (correoElectronicoInstitucional = correoElectronicoInstitucional.toLowerCase())" placeholder="Correo electrónico institucional" aria-describedby="textoExtraDeNotificacion" />
                                        <div class="input-group-append" style="height: 33px">
                                            <span class="input-group-text" id="textoExtraDeNotificacion">&commat;notificacionespjags.gob.mx</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <ul class="col-md-12">
                                        <li>
                                            <i v-if="tipoDeFuerza.letraMinuscula == true" class="fas fa-check-circle verdeFuerte"></i>
                                            <i v-else class="fas fa-times-circle rojo"></i>
                                            &nbsp;&nbsp;Es requerido mínimo una letra minúscula.
                                        </li>
                                        <li>
                                            <i v-if="tipoDeFuerza.letraMayuscula == true" class="fas fa-check-circle verdeFuerte"></i>
                                            <i v-else class="fas fa-times-circle rojo"></i>
                                            &nbsp;&nbsp;Es requerido mínimo una letra mayúscula.
                                        </li>
                                        <li>
                                            <i v-if="tipoDeFuerza.numero == true" class="fas fa-check-circle verdeFuerte"></i>
                                            <i v-else class="fas fa-times-circle rojo"></i>
                                            &nbsp;&nbsp;Es requerido mínimo un número.
                                        </li>
                                        <li>
                                            <i v-if="tipoDeFuerza.caracterEspecial == true" class="fas fa-check-circle verdeFuerte"></i>
                                            <i v-else class="fas fa-times-circle rojo"></i>
                                            &nbsp;&nbsp;Es requerido mínimo un carácter especial.
                                        </li>
                                        <li>
                                            <i v-if="tipoDeFuerza.cantidadDeLetras == true" class="fas fa-check-circle verdeFuerte"></i>
                                            <i v-else class="fas fa-times-circle rojo"></i>
                                            &nbsp;&nbsp;Es requerido un mínimo de 8 letras.
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="contrasena">Ingrese la nueva contraseña</label>
                                    <input id="contrasena" class="form-control form-control-claro" type="password" v-model="contrasena" placeholder="Nueva contraseña" v-on:keyup="validarLaFuerzaDeLaContrasena()" />
                                    <label :class="claseDeFuerza" v-html="nivelDeFuerza"></label>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="confirmarContrasena">Confirme la nueva contraseña</label>
                                    <input id="confirmarContrasena" class="form-control form-control-claro" type="password" v-model="confirmarContrasena" placeholder="Confirme la nueva contraseña" v-on:keyup="ValidaQueSeanIdenticasLasContrasenas(true)" />
                                </div>
                                <div class="form-group col-12" v-if="sonContrasenasIdenticas == false">
                                    <label class="rojo">Las contraseñas ingresadas no son las mismas.</label>
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-primary overwrapDeBotones" id="guardarCorreoElectronicoInstitucional" v-on:click="GuardarCorreoElectronicoInstitucional()"><i class="fa fa-save"></i>&nbsp;&nbsp;Guardar correo electrónico institucional</button>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <br />
    </div>
</template>

<script>
    import enumeraciones from '@/../static/js/enumeraciones'
    import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
    import catalogos from '@/../static/js/catalogos'
    import api from '@/../static/js/api'
    import comun from '@/../static/js/comun'
    import axios from 'axios'

    export default {
        data() {
            return {
                enumeraciones,
                enumeraciones_sicpo,
                nombres: "",
                primerApellido: "",
                segundoApellido: "",
                correoElectronico: "",
                confirmeCorreoElectronico: "",
                sonCorreosPersonalesIdenticos: true,
                sonContrasenasIdenticas: true,
                correoElectronicoInstitucional: "",
                contrasena: "",
                confirmarContrasena: "",
                nivelDeFuerza: "",
                claseDeFuerza: "",
                fuerza: 0,
                tipoDeFuerza: {
                    letraMinuscula: false,
                    letraMayuscula: false,
                    numero: false,
                    caracterEspecial: false,
                    cantidadDeLetras: false
                },
                nombreDeVariableDelComponente: "cargoPaginaOficial"
            }
        },
        mounted() {
            this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
            $("#correoElectronicoInstitucional").keypress(function (e) {
                if (e.which == 32 || e.which == 64)
                    e.preventDefault();
            });
        }, 
        methods: {
            validarLaFuerzaDeLaContrasena: function() {
                this.fuerza = 0;
        
                if (this.contrasena.match(/[a-z]+/)) {
                    this.tipoDeFuerza.letraMinuscula = true;
                    this.fuerza += 1;
                } else {
                    this.tipoDeFuerza.letraMinuscula = false;
                }
                if (this.contrasena.match(/[A-Z]+/)) {
                    this.tipoDeFuerza.letraMayuscula = true;
                    this.fuerza += 1;
                } else {
                    this.tipoDeFuerza.letraMayuscula = false;
                }
                if (this.contrasena.match(/[0-9]+/)) {
                    this.tipoDeFuerza.numero = true;
                    this.fuerza += 1;
                } else {
                    this.tipoDeFuerza.numero = false;
                }
                if (this.contrasena.match(/[ ¡!"#$%&'()*+,-.:;<=>¿?@^_`{|}~\\/]+/)) {
                    this.tipoDeFuerza.caracterEspecial = true;
                    this.fuerza += 1;
                } else {
                    this.tipoDeFuerza.caracterEspecial = false;
                }

                switch (this.fuerza) {
                    case 0:
                        this.claseDeFuerza = "nivelDeFuerza rojo";
                        this.nivelDeFuerza = "";
                        break;
                    case 1:
                        this.claseDeFuerza += "nivelDeFuerza rojo";
                        this.nivelDeFuerza = "La contraseña es débil.";
                        break;
                    case 2:
                        this.claseDeFuerza += "nivelDeFuerza amarillo";
                        this.nivelDeFuerza = "La contraseña es buena.";
                        break;
                    case 3:
                        this.claseDeFuerza += "nivelDeFuerza verde";
                        this.nivelDeFuerza = "La contraseña es fuerte.";
                        break;
                    case 4:
                        this.claseDeFuerza += "nivelDeFuerza verdeFuerte";
                        this.nivelDeFuerza = "La contraseña es bastante fuerte.";
                        break;
                }

                if (this.contrasena.length < 8) {
                    this.tipoDeFuerza.cantidadDeLetras = false;
                if(this.nivelDeFuerza != "")
                    this.nivelDeFuerza += "<br />";
                    this.nivelDeFuerza += "El mínimo numero de caracteres permitido es 8.";
                } else {
                    this.tipoDeFuerza.cantidadDeLetras = true;
                }

                this.ValidaQueSeanIdenticasLasContrasenas(true);
            },
            validarQueSeanIdenticasYFuertesLasContrasenas: function () {
                if(this.fuerza < 4) {
                    comun.mensajeDeAlerta("La contraseña no es lo suficientemente fuerte.<br/>Corrija los errores e inténtelo de nuevo.", null, null);
                    return false;
                }
                if (this.contrasena.length < 8) {
                    comun.mensajeDeAlerta("El mínimo numero de caracteres permitido es 8.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }
                if(!this.ValidaQueSeanIdenticasLasContrasenas(false)){
                    return false;
                }

                return true;
            },
            ValidaQueSeanIdenticosLosCorreosPersonales: function(EsModificacionSobreCampo) {
                if(this.correoElectronico != this.confirmeCorreoElectronico) {
                    if(EsModificacionSobreCampo) {
                        this.sonCorreosPersonalesIdenticos = false
                    } else {
                        comun.mensajeDeAlerta("Los correos personales ingresados no son los mismos.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                        return false;
                    }
                } else {
                    if(EsModificacionSobreCampo) {
                        this.sonCorreosPersonalesIdenticos = true
                    } else {
                        return true;
                    }
                }
            },
            ValidaQueSeanIdenticasLasContrasenas: function(EsModificacionSobreCampo) {
                if(this.contrasena !== this.confirmarContrasena) {
                    if(EsModificacionSobreCampo) {
                        this.sonContrasenasIdenticas = false
                    } else {
                        comun.mensajeDeAlerta("Las contraseñas ingresadas no son las mismas.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                        return false;
                    }
                } else {
                    if(EsModificacionSobreCampo) {
                        this.sonContrasenasIdenticas = true
                    } else {
                        return true;
                    }
                }
            },
            ValidarQueTodaLaInformacionEsteIngresada: function() {
                if(this.nombres == "" || this.nombres == null) {
                    comun.mensajeDeAlerta("No ha ingresado su nombre.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }

                if((this.primerApellido != "" && this.primerApellido != null) || (this.segundoApellido != "" && this.segundoApellido != null)) {
                    
                } else {
                    comun.mensajeDeAlerta("Se necesita que se ingrese minimo un apellido.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }

                if(this.correoElectronico == "" || this.correoElectronico == null || !comun.EsCorreoElectronico(this.correoElectronico, false)) {
                    comun.mensajeDeAlerta("El correo electrónico personal ingresado no es valido.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }

                if(!this.ValidaQueSeanIdenticosLosCorreosPersonales(false)){
                    return false;
                }

                if(this.correoElectronicoInstitucional == "" || this.correoElectronicoInstitucional == null || !comun.EsCorreoElectronico(this.correoElectronicoInstitucional, true) || this.correoElectronicoInstitucional.includes('@')) {
                    comun.mensajeDeAlerta("El correo electrónico institucional ingresado no es valido.<br/>Corrija el error e inténtelo de nuevo.", null, null);
                    return false;
                }

                if(!this.validarQueSeanIdenticasYFuertesLasContrasenas()){
                    return false;
                }

                return true;
            }, 
            GuardarCorreoElectronicoInstitucional: function() {
                if(this.ValidarQueTodaLaInformacionEsteIngresada()) {
                    comun.SeEstaCargandoInformacion(true, true);

                    const parametros = {
                        Nombres: this.nombres, 
                        PrimerApellido: this.primerApellido, 
                        SegundoApellido: this.segundoApellido, 
                        CorreoElectronicoPersonal: this.correoElectronico, 
                        CorreoElectronicoInstitucional: this.correoElectronicoInstitucional, 
                        Contrasena: this.contrasena, 
                        EsPrueba: this.enumeraciones.EsPrueba
                    }

                    axios.post(
                        api.conexion + api.PaginaOficial.funcion.NotificacionesElectronicas.GuardaElCorreoElectronicoInstitucional,
                        parametros
                        ).then(respuesta => {
                            if(respuesta.data.SiHayError){
                                console.log(respuesta);
                                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            } else {
                                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                this.LimpiarLaNotificacionElectronica();
                            }

                            comun.SeEstaCargandoInformacion(false, true);
                        }
                        ).catch(excepcion => {
                            console.log(excepcion);
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false, true);
                        });
                }
            }, 
            LimpiarLaNotificacionElectronica: function() {
                this.nombres = "";
                this.primerApellido = "";
                this.segundoApellido = "";
                this.correoElectronico = "";
                this.confirmeCorreoElectronico = "";
                this.correoElectronicoInstitucional = "";
                this.contrasena = "";
                this.confirmarContrasena = "";
                this.validarLaFuerzaDeLaContrasena();
                this.ValidaQueSeanIdenticosLosCorreosPersonales(true);
            }
        }
    }
</script>

<style scoped>
    .page-title {
        background-color: rgb(0,117,115);
        color: #FFF;
        padding: 2vh 20vw;
    }

    a {
        color: white !important;
    }

    ul {
        padding-left: 0;
    }

    li {
        list-style-type: none;
    }

    .rojo {
        color: red;
    }

    .amarillo {
        color: rgb(190, 190, 38);
    }

    .verde {
        color: rgb(27, 192, 27);
    }

    .verdeFuerte {
        color: darkgreen;
    }

    .nivelDeFuerza {
        padding-top: 3px;
        padding-bottom: 3px;
    }

    @media(max-width: 991px) {
        #irAlBuzonDeNotificacionesElectronicas_div {
            padding-top: 0;
            padding-bottom: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/NotificacionElectronica/NotificacionElectronica.vue